// 全キー消去機能
import error from '../../../../common/nodejs/errors';
import constants from '../../../../common/nodejs/constants';
import { IMB_ERROR } from '../constants';
import { getErrorMessageKey, getErrorMessageKeyIocpRcidStatus } from '../errorMsgClient';
import api from '../../../../common/api';

export const DELETE_ALL_KEYS_ACTION = {
  NONE: 'NONE',
  PAUSE_WATCHER: 'PAUSE_WATCHER',
  END_PROCESS: 'END_PROCESS',
  IGOFF_ACTION: 'IGOFF_ACTION',
  CONTINUE: 'CONTINUE',
};

// 進行状態系
export const IMB_DELETE_ALL_KEYS_PROGRESS_LIST = [
  {
    // 全キー消去正常終了
    imbStatus: constants.IMB_SYS_STATUS_FINISHED_PROCESS,
    errCode: error.SUCCESS,
    imbComplete: true,
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-success'
  },
  {
    // IGN-ON指示
    imbStatus: constants.IMB_STATUS_IGON_EXPECTED,
    errCode: error.SUCCESS,
    imbComplete: false,
    action: DELETE_ALL_KEYS_ACTION.PAUSE_WATCHER,
    dialogId: 'delete-all-keys-confirm-ig-on'
  },
  {
    // 登録キー数確認
    imbStatus: constants.IMB_STATUS_CHECKING_THE_NUMBER_OF_REGISTER_KEYS,
    errCode: error.SUCCESS,
    imbComplete: false,
    action: DELETE_ALL_KEYS_ACTION.CONTINUE,
    dialogId: ''
  },
  {
    // 初期化通信中
    imbStatus: constants.IMB_STATUS_INITIALIZATION_COMMUNICATION,
    errCode: error.SUCCESS,
    imbComplete: false,
    action: DELETE_ALL_KEYS_ACTION.NONE,
    dialogId: 'delete-all-keys-progress-comm-imb-cm'
  },
  {
    // 全キー消去実行中
    imbStatus: constants.IMB_STATUS_DELETE_ALL_KEY_IN_PROGRESS,
    errCode: error.SUCCESS,
    imbComplete: false,
    action: DELETE_ALL_KEYS_ACTION.NONE,
    dialogId: 'delete-all-keys-processing'
  },
  {
    //igoffの場合
    imbStatus: constants.IMB_STATUS_IGNITION_OFF,
    errCode: error.IMB_CANNOT_CONFIRM_IGON_ERROR,
    imbComplete: false,
    action: DELETE_ALL_KEYS_ACTION.IGOFF_ACTION,
    dialogId: '',
  },
  {
    // キー未登録エラー（Type2の場合）
    imbStatus: constants.IMB_STATUS_KEY_NOT_FOUND,
    errCode: error.SUCCESS,
    imbComplete: false,
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-warning-key-not-found'
  },
];

// エラー系
export const IMB_DELETE_ALL_KEYS_ERROR_MAP = {
  // キー未登録エラー（Type3の場合）
  [IMB_ERROR.IMB_NO_REGISTERED_KEY_READ_ERROR]: {
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-warning-key-not-found'
  },
  // 全キー消去キャンセル
  [IMB_ERROR.IMB_DELETE_ALL_KEYS_CANCELLED_ERROR]: {
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-warning-cancel'
  },
  // RCID通信エラー
  [error.IOCP_RCID_NUMBER_OF_REGISTERED_KEYS_ERROR]: {
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-failure'
  },
  // モード移行失敗エラー
  [IMB_ERROR.IMB_MODE_TRANSITION_ERROR]: {
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-failure'
  },
  // 全キー消去エラー
  [IMB_ERROR.IMB_DELETE_ALL_KEYS_FAILURE_ERROR]: {
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-failure'
  },
  // 車両通信エラー
  [error.IMB_ABNORMAL_TERMINATION_ERROR]: {
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-failure'
  },
  // OTPW失効エラー
  [IMB_ERROR.IMB_EXPIRE_OTPW_ERROR]: {
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-failure'
  },
  // DLLダウンロード失敗エラー
  [error.IMB_SEQUENCE_NOT_FOUND]: {
    action: DELETE_ALL_KEYS_ACTION.END_PROCESS,
    dialogId: 'delete-all-keys-failure'
  },
};

export const imbDeleteAllKeysError = {
  [error.IOCP_RCID_NUMBER_OF_REGISTERED_KEYS_ERROR]: (res, context) => {
    return context.$t(getErrorMessageKeyIocpRcidStatus(res.message, context.vehicleType, res.systems[0].system_name)) + '</br>' +
      context.$t('imb.common_num_reg_keys_without_unit', [res.num_of_registered_keys]);
  },
  [IMB_ERROR.IMB_MODE_TRANSITION_ERROR]: (res, context) => {
    return getErrorMessageKey(context, res.error_code) + '</br>' +
      context.$t('imb.common_num_reg_keys_without_unit', [res.num_of_registered_keys]);
  },
  [IMB_ERROR.IMB_DELETE_ALL_KEYS_FAILURE_ERROR]: (res, context) => {
    return getErrorMessageKey(context, res.error_code) + '</br>' +
      context.$t('imb.common_num_reg_keys_without_unit', [res.num_of_registered_keys]) + '</br>' +
      context.$t('imb.error_delete_all_keys_retry');
  },
  [error.IMB_ABNORMAL_TERMINATION_ERROR]: (res, context) => {
    return context.$t((getErrorMessageKey(context, res.error_code, context.vehicleType)), [res.message]);
  },
  [IMB_ERROR.IMB_EXPIRE_OTPW_ERROR]: (res, context) => {
    return getErrorMessageKey(context, res.error_code);
  },
  [error.IMB_SEQUENCE_NOT_FOUND]: (_, context) => {
    return context.$t(api.getErrorMessageForCode(error.IMB_SEQUENCE_NOT_FOUND));
  },
};

export default {
  IMB_DELETE_ALL_KEYS_PROGRESS_LIST,
  IMB_DELETE_ALL_KEYS_ERROR_MAP,
  imbDeleteAllKeysError,
};
